var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8196 13.1319L10.0771 3.60826C9.85081 3.23308 9.43811 3 8.99999 3C8.56186 3 8.14916 3.23308 7.92289 3.60829L2.18034 13.1319C1.94653 13.5197 1.93961 14.0055 2.16227 14.3998C2.38498 14.7941 2.8046 15.039 3.25741 15.039H14.7426C15.1954 15.039 15.615 14.7941 15.8377 14.3998C16.0604 14.0054 16.0535 13.5196 15.8196 13.1319ZM15.044 13.9516C14.9827 14.0601 14.8672 14.1276 14.7426 14.1276H3.25741C3.13275 14.1276 3.01723 14.0601 2.95595 13.9516C2.89464 13.8431 2.89656 13.7093 2.9609 13.6026L8.7035 4.07896C8.76579 3.97568 8.8794 3.9115 9.00001 3.9115C9.1206 3.9115 9.23421 3.97568 9.2965 4.07896L15.039 13.6026C15.1034 13.7093 15.1054 13.8431 15.044 13.9516Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01249 11.6807C8.64043 11.6807 8.36133 11.9766 8.36133 12.3318C8.36133 12.6785 8.6404 12.983 9.01249 12.983C9.35921 12.983 9.65521 12.6785 9.65521 12.3318C9.65521 11.9766 9.35918 11.6807 9.01249 11.6807Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00403 6.75C8.65731 6.75 8.38672 6.93605 8.38672 7.26587C8.38672 8.27217 8.50509 9.71822 8.50509 10.7246C8.50512 10.9867 8.73346 11.0966 9.00406 11.0966C9.207 11.0966 9.49452 10.9867 9.49452 10.7246C9.49452 9.71825 9.61289 8.2722 9.61289 7.26587C9.61289 6.93607 9.33385 6.75 9.00403 6.75Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.7a10fef8a3df8228e9d62c8797c5bb66.svg";
export { ForwardRef as ReactComponent };